
import IconButton from "../../../items/iconButton";
import volumeButton from "../../../items/volumeButton";
import directionButton from "../../../items/directionButton";
import topTips from "../../../items/topTips";
import actionButton from "../../../items/actionButton";
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { getRemoteIdList, getIrs, getAirIrs } from "../../../api/kookong.js";
import { sendCmd, addSubDevice, updateDevInfo } from "../../../api/index.js";
import { windVane } from "../../../utils/tmallGenius";
import { RemoteParams } from "../../../utils/device/set/remote";

export default {
components: {
IconButton, //图标
Flexbox,
FlexboxItem,
volumeButton,
directionButton,
topTips,
actionButton,
Loading
},
created() {
this.getList().then(res => {
this.isLoading = false;
this.irDataList = res;
});
},

data() {
return {
irDataList: [],
isLoading: false,
currentNum: 0,
currentCmd: {
mode: 0,
fid: 1,
power: 1,
temp: 26,
direct: 0,
speed: 0
},
currentRid: {
power: 0, //开关机状态 “开机:0，关机:1”
mode: 0, //模式 “制冷:0，制热:1，自动:2，送风:3，除湿:4”
temp: 26, //温度,如果没法设置温度，请传入-1 或者不传 “16 度-30 度”
speed: 0, // 风量,如果没法设置风量，请传入-1 或者不传 “自动:0，低:1，中:2，高:3”
direct: 0, //风向 “扫风:0， 固定风 1-n” ”如果是只有 0 表示没有风向，只有 1 表示不区分扫风和固 定风，就一个风向“
fid: "" //按键id ”电源:1,模式:2，温度+:3，温度-:4，风量:5，扫风:6，固定风:7”
}
};
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("空调遥控器");
next();
},
methods: {
getMode(val) {
const data = {
0: "制冷",
1: "制热",
2: "自动",
3: "送风",
4: "除湿"
};
return data[val];
},
getDirect(val) {
const data = {
0: "扫风",
1: "固定风"
};
return data[val];
},
getSpeed(val) {
const data = {
0: "自动",
1: "低",
2: "中",
3: "高"
};
return data[val];
},
/**@name 发送命令
*
*/
onClick: function(val) {
let data;
switch (val) {
case "mode": //模式 “制冷:0，制热:1，自动:2，送风:3，除湿:4”


this.currentCmd.fid = 2;
data = {
action: "send",
...this.currentCmd,
rid: this.irDataList[this.currentNum]
};
this.getIr(data).then(res => {
const data = {
freq: res.data.frequency,
list: res.data.pulse
};
this.sendAirCmd(data);
});
this.currentCmd.mode = this.currentCmd.mode + 1;
if (this.currentCmd.mode > 4) {
this.currentCmd.mode = 0;
}
break;
case "power":
if (this.currentCmd.power == 0) {
this.currentCmd.power = 1;
} else {
this.currentCmd.power = 0;
}
this.currentCmd.fid = 1;
data = {
action: "send",
...this.currentCmd,
rid: this.irDataList[this.currentNum]
};
this.getIr(data).then(res => {
const data = {
freq: res.data.frequency,
list: res.data.pulse
};
this.sendAirCmd(data);
});

break;
case "direct":
this.currentCmd.fid = 6;
this.currentCmd.direct = 0;
data = {
action: "send",
...this.currentCmd,
rid: this.irDataList[this.currentNum]
};
this.getIr(data).then(res => {
const data = {
freq: res.data.frequency,
list: res.data.pulse
};
this.sendAirCmd(data);
});
break;
case "heating":
this.currentCmd.fid = 2;
this.currentCmd.mode = 1;
data = {
action: "send",
...this.currentCmd,
rid: this.irDataList[this.currentNum]
};
this.getIr(data).then(res => {
const data = {
freq: res.data.frequency,
list: res.data.pulse
};
this.sendAirCmd(data);
});
break;
case "refrigeration":
this.currentCmd.fid = 2;
this.currentCmd.mode = 0;
data = {
action: "send",
...this.currentCmd,
rid: this.irDataList[this.currentNum]
};
this.getIr(data).then(res => {
const data = {
freq: res.data.frequency,
list: res.data.pulse
};
this.sendAirCmd(data);
});
break;
case "tempPlus":
this.currentCmd.fid = 3;
this.currentCmd.temp;
this.currentCmd.temp = this.currentCmd.temp + 1;
if (this.currentCmd.temp > 30) {
this.currentCmd.temp = 30;
return;
}
data = {
action: "send",
...this.currentCmd,
rid: this.irDataList[this.currentNum]
};
this.getIr(data).then(res => {
const data = {
freq: res.data.frequency,
list: res.data.pulse
};
this.sendAirCmd(data);
});
break;
case "tempSub":
this.currentCmd.fid = 4;
this.currentCmd.temp = this.currentCmd.temp - 1;
if (this.currentCmd.temp < 17) {
this.currentCmd.temp = 17;
return;
}
data = {
action: "send",
...this.currentCmd,
rid: this.irDataList[this.currentNum]
};
this.getIr(data).then(res => {
const data = {
freq: res.data.frequency,
list: res.data.pulse
};
this.sendAirCmd(data);
});
break;
case "windDirection":
this.currentCmd.direct = 1;
this.currentCmd.fid = 7;
data = {
action: "send",
...this.currentCmd,
rid: this.irDataList[this.currentNum]
};
this.getIr(data).then(res => {
const data = {
freq: res.data.frequency,
list: res.data.pulse
};
this.sendAirCmd(data);
});
break;
case "airVolume":
this.currentCmd.fid = 5;
this.currentCmd.speed++;
if (this.currentCmd.speed > 3) {
this.currentCmd.speed = 0;
}
data = {
action: "send",
...this.currentCmd,
rid: this.irDataList[this.currentNum]
};
this.getIr(data).then(res => {
const data = {
freq: res.data.frequency,
list: res.data.pulse
};
this.sendAirCmd(data);
});
break;
}
},
sendAirCmd(param) {
const pluseList = param.list.split(",");
const data = {
token: sessionStorage.getItem("token"),
cmd: "15",
uid: this.$route.query.uid,
deviceId: this.$route.query.deviceId, // 小方配置遥控器添加“1”
order: "ir control",
value1: 0,
value2: 0,
value3: 0,
value4: 0,
freq: param.freq,
pluseNum: pluseList.length,
pluseData: param.list
};
sendCmd(data).then(res => {});
},
next: function(val) {
this.currentNum = val - 1;
},
pre: function(val) {
this.currentNum = val - 1;
},
/**@name 绑定确定当前遥控器
*/
current: function() {
const remoteParams = new RemoteParams();
remoteParams.brandId = this.$route.query.bid;
const data = {
token: sessionStorage.getItem("token"),
uid: this.$route.query.uid,
deviceType: this.$route.query.deviceType,
deviceName: "空调遥控器",
roomId: "",
rid: this.irDataList[this.currentNum],
company: remoteParams.transToString()
};
addSubDevice(data)
.then(res => {
if (res.status === 0) {
this.toast_success();
let device = res.data;

updateDevInfo({

m: "updateZone",
token: sessionStorage.getItem("token"),
deviceId: device.deviceId,
zone: this.$route.query.aligenieZone
});
setTimeout(() => {
this.$router.replace("/device/xiaofang/tips?deviceName=air&deviceId=" + device.deviceId);
}, 2000);
} else {
this.toast_fail();
}
})
.catch(res => {
this.toast_fail();
});
},
toTutorial: function() {
this.$router.push("/tutorial");
},
setRid() {
const data = this.irDataList[this.currentNum];
if (!data) {
return;
}
},
getList() {
const data = {
deviceType: this.$route.query.kookongDeviceType,
brandId: this.$route.query.bid
};
this.isLoading = true;
return getRemoteIdList(data).then(res => {
return res.data;
});
},
getIr(data) {
return getAirIrs(data).then(res => {
return res;
});
}
}
};



// WEBPACK FOOTER //
// ./src/pages/device/air/Index.vue